import { combineReducers } from "redux";
import PowerPostionReducer from "./powerPostionReducer";
import BasicDetailsReducer from "./basicDetailsReducer";
import TargetValueReducer from "./targetValuesReducer";
import salesRepClassificationReducer from "./salesRepClassificationReducer";
import ToastMessageReducer from "./toastMessageReducer";
import profileDetailsReducer from "./profileDetailsReducer";
import DashboardReducer from "./dashboardReducer";
import SelectedActionTilesReducer from "./selectedActionTilesReducer";
import NegotiationActionsReducer from "./negotiationActionsReducer";
import DocumentOutcomeReducer from "./DocumentOutcomeReducer";
import CloseNegotiationReducer from "./closeNegotiationReducer";

const rootReducer = combineReducers({
  powerPosition: PowerPostionReducer,
  basicDetails: BasicDetailsReducer,
  TargetValue: TargetValueReducer,
  negotiationActions: NegotiationActionsReducer,
  salesRepClassification: salesRepClassificationReducer,
  toastMessageReducer: ToastMessageReducer,
  selectedActionTiles: SelectedActionTilesReducer,
  profile: profileDetailsReducer,
  dashboardData: DashboardReducer,
  DocumentOutcome:DocumentOutcomeReducer,
  closeNegotiation:CloseNegotiationReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
